function betaSignup(passportdata) {

    $(document).on('logged-in', function(event,passportdata){

        if( !!_ppprotect.length) {

            var privhtml = $('.pcontent').html();

            $('.pcontent').remove();

            //_ppprotect.fadeTo(300,0);
            setTimeout(function(){

                _ppprotect.html(privhtml);

                _ppprotect.fadeTo(300,1);

                $('.ppgpem').html(passportdata.email);
                var gp = $('#gplayemail').attr('placeholder');
                var gplay = $('.gplay');
                var ostoggle = $('.ostoggle');
                var type = $('#type');
                var btnios = $('.iosbtn');
                var btnandroid = $('.androidbtn');
                var deletebeta = $('.btn-delete-beta');

                //$('#gplayemail').attr('placeholder', gp+': '+passportdata.email)

                btnios.on('click', function(e){
                    e.preventDefault();
                    var el = $(this);
                    type.val(el.data('type'));
                    ostoggle.removeClass('registering').removeClass('btnactive');
                    el.addClass('registering');
                    gplay.slideUp(300);
                    betaRegister();
                    setTimeout(function(){
                      $('.beta1').slideUp(500, 'easeInOutExpo');
                      $('.beta2').slideDown(500, 'easeInOutExpo');
                    }, 1500);
                });

                btnandroid.on('click', function(e){
                    e.preventDefault();
                    var el = $(this);
                    type.val(el.data('type'));
                    ostoggle.removeClass('registering').removeClass('btnactive');
                    el.addClass('btnactive');
                    gplay.slideDown(300);
                });


                $('#beta-signup').on('submit', function(e) {
                    e.preventDefault();
                    //btnandroid.addClass('registering');
                    if( $('#gplayemail').val() == '') {
                      $('#gplayemail').addClass('error');
                      return;
                    }
                    $('#betaformbtn').addClass('registering');
                    betaRegister();
                    setTimeout(function(){
                      $('.beta1').slideUp(500, 'easeInOutExpo');
                      $('.beta2').slideDown(500, 'easeInOutExpo');
                    }, 1500);
                });

                betaRegistered(passportdata);

                deletebeta.on('click', function(e){
                    e.preventDefault();
                    var answer = confirm ("Are you sure you want to cancel your Ultra Worldwide App Beta Registration?");
                    if (answer) {
                      passport.unregister('worldwide-beta');
                      $('.beta1').slideDown(500, 'easeInOutExpo');
                      $('.beta2').slideUp(500, 'easeInOutExpo');
                      $('.registering').removeClass('registering');
                    }
                })

            },350);

        }

    });

}

function betaRegister() {

    var regdata = {
        email: $('#gplayemail').val(),
        source: document.location.hostname,
        type: $('#type').val(),
    };

    //log(regdata);
    //return;
    passport.register('worldwide-beta', regdata)
    .done(function (newdata, textStatus) {
        var updated = passport.info();
        updated.done(function(data) {
            betaRegistered(data);
        });
    })
    .fail(function (jqXHR, textStatus, error) {
      //log(jqXHR,textStatus,error);
    });


}



function betaRegistered(passport) {

    if(passport.registrations) {

        $.each(passport.registrations, function(key, value) {

            if(value.code == 'worldwide-beta') {

                $('.beta2 ul').find('li.email').remove();
                $('.beta1').slideUp(500, 'easeInOutExpo');
                $('.beta2').slideDown(500, 'easeInOutExpo');

                $('.beta2 strong').each(function(){
                    var el = $(this);
                    var field = el.data('field');
                    if(field == 'type') {
                        el.html(value.type);
                        if(value.type == 'Android' && value.email.length) {
                          $('.beta2 ul').append('<li class="email">Email: <strong>'+value.email+'</strong></li>')
                        }
                    }
                    if(field == 'registered_at') {
                        var regdate = moment(value.created_at).format('MMMM Do, YYYY');
                        el.html(regdate);
                    }
                    if(field == 'accepted') {
                        if(!value.accepted) {
                          value.accepted = 'Pending';
                        } else {
                          value.accepted = 'Accepted';
                        }
                        el.html(value.accepted);
                    }
                })
            }

        });
    }

    $(document).trigger('rebuild-page');

}